import { makeStyles } from '@material-ui/core/styles'

const BRAND_NAVY = '#001C57'
const MUTED_TEXT = '#6B7C87'
const BODY_TEXT = '#425D69'

export const useStyles = makeStyles(theme => ({
  sessionsSection: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
  sessionList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  layout: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)',
    gap: theme.spacing(3),
    alignItems: 'start',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  layoutSingleColumn: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(3),
    alignItems: 'start',
    width: '100%',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    width: '100%',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    width: '100%',
    minWidth: 0,
    minHeight: 40,
    flexWrap: 'wrap',
  },
  sectionTitle: {
    margin: 0,
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
    textTransform: 'uppercase',
    color: MUTED_TEXT,
  },
  sectionLink: {
    color: theme.palette.primary.main,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    padding: 0,
    minWidth: 0,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
  sessionsSectionHeader: {
    marginBottom: theme.spacing(0.5),
    minHeight: 0,
  },
  sessionTabs: {
    marginTop: 0,
    marginBottom: theme.spacing(2),
    minHeight: 36,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  sessionTab: {
    minWidth: 0,
    minHeight: 36,
    paddingTop: theme.spacing(0.75),
    paddingBottom: theme.spacing(0.75),
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.4,
  },
  sessionTabPanel: {
    width: '100%',
    minWidth: 0,
  },
  sessionCard: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(3),
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    minWidth: 0,
  },
  nextSessionCard: {
    gap: theme.spacing(2.5),
    cursor: 'pointer',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: '#B0BEC5',
      boxShadow: '0 2px 8px rgba(0, 32, 91, 0.06)',
    },
  },
  nextSessionBody: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2.5),
    minWidth: 0,
  },
  dateBadge: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 72,
    minHeight: 88,
    padding: theme.spacing(1.5, 1),
    borderRadius: 12,
    backgroundColor: '#F4F7F9',
    color: BRAND_NAVY,
    textAlign: 'center',
  },
  dateBadgeMonth: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
  },
  dateBadgeDay: {
    fontSize: '1.75rem',
    fontWeight: 700,
    lineHeight: 1.1,
    margin: theme.spacing(0.25, 0),
  },
  dateBadgeWeekday: {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.3,
  },
  sessionCopy: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: 0,
    flex: '1 1 auto',
  },
  sessionTitle: {
    margin: 0,
    marginBottom: theme.spacing(0.75),
    fontFamily: '"Source Serif Pro", serif',
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: 1.25,
    color: '#00234B',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
    },
  },
  sessionMeta: {
    margin: 0,
    marginBottom: theme.spacing(1.5),
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: BODY_TEXT,
  },
  timePill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 999,
    backgroundColor: '#F4F7F9',
    color: BRAND_NAVY,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    '& svg': {
      fontSize: 16,
    },
  },
  laterSessionCard: {
    gap: theme.spacing(1.5),
    cursor: 'pointer',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: '#B0BEC5',
      boxShadow: '0 2px 8px rgba(0, 32, 91, 0.06)',
    },
  },
  laterSessionBody: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  dateCompact: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#F4F7F9',
    color: BRAND_NAVY,
    textAlign: 'center',
  },
  dateCompactWeekday: {
    fontSize: '0.625rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    lineHeight: 1.2,
  },
  dateCompactDay: {
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: 1.1,
  },
  laterSessionTitle: {
    margin: 0,
    marginBottom: theme.spacing(0.5),
    fontWeight: 700,
    fontSize: '0.9375rem',
    lineHeight: 1.4,
    color: BRAND_NAVY,
  },
  laterSessionMeta: {
    margin: 0,
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: MUTED_TEXT,
  },
  emptyStateContent: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  dialogList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  dialogListItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    width: '100%',
    padding: theme.spacing(2),
    border: '1px solid #E0E0E0',
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#B0BEC5',
      backgroundColor: '#FAFBFC',
    },
  },
  dialogListCopy: {
    minWidth: 0,
    flex: '1 1 auto',
  },
  dialogListTitle: {
    margin: 0,
    marginBottom: theme.spacing(0.25),
    fontWeight: 600,
    fontSize: '0.9375rem',
    lineHeight: 1.4,
    color: BRAND_NAVY,
  },
  dialogListMeta: {
    margin: 0,
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: MUTED_TEXT,
  },
  text: {
    margin: theme.spacing(2, 0),
  },
}))
